module.exports = "/wp-content/themes/conversion/public/dist//svgs/icon-arrow-right.svg";